import React from 'react'
import { InputAdornment, TextField, Typography } from '@material-ui/core'
import { KSAFlagIcon } from '../SVGIcons'

import { useStyles } from './MobileNumberInput.styles'

const SAUDI_COUNTRY_CODE = '+966'
const SAUDI_MOBILE_PREFIX = '5'

const MobileNumberInput = ({
  id = '',
  // TextFieldPros
  ...props
}) => {
  const styles = useStyles()

  const prefix = (
    <Typography variant="body1">
      <span className={styles.mobilePrefix}>{SAUDI_COUNTRY_CODE}</span>
      &nbsp;{SAUDI_MOBILE_PREFIX}
    </Typography>
  )

  return (
    <TextField
      dir="ltr"
      id={`${id}-mobileNumber`}
      type={'tel'}
      fullWidth
      color="secondary"
      required
      inputProps={{ maxLength: 8 }}
      {...props}
      InputProps={{
        className: styles.inputWrapper,
        startAdornment: (
          <InputAdornment position="start">
            <KSAFlagIcon className={styles.flag} />
            {prefix}
          </InputAdornment>
        ),
      }}
    />
  )
}
export default MobileNumberInput
